'use client'
import { AlgoliaContextProvider } from '@/context'
import { HitsWithFacets } from '../products'
import PageTitle from '../page-title'
import { SortInput } from '@/components'

type Props = {
  searchParams: Record<string, string>
}

const ShopResults = ({ searchParams }: Props) => {
  return (
    <AlgoliaContextProvider searchParams={searchParams}>
      <PageTitle title="Shop">
        <SortInput
          options={[
            {
              label: 'DEFAULT',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS}`
            },
            {
              label: 'NAME: A-Z',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS}_sort_az`
            },
            {
              label: 'NAME: Z-A',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS}_sort_za`
            },
            {
              label: 'PRICE: LOWEST TO HIGHEST',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS}_sort_price_asc`
            },
            {
              label: 'PRICE: HIGHEST TO LOWEST',
              value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS}_sort_price_desc`
            }
          ]}
        />
      </PageTitle>

      <section id="results-container" className="pb-6">
        <HitsWithFacets />
      </section>
    </AlgoliaContextProvider>
  )
}

export default ShopResults
